import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile",
  "use": "icon-mobile-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mobile\"><path d=\"M288 0C217.4 0 160 57.4 160 128v768c0 70.6 57.4 128 128 128h448c70.6 0 128-57.4 128-128V128c0-70.6-57.4-128-128-128H288z m224 800a64 64 0 1 1 0 128 64 64 0 1 1 0-128z\" p-id=\"16902\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol